import React, { ReactElement, useState } from "react";
import { Drawer, ConfigProvider } from "antd";
import customizeTheme from "components/customize-theme";
import Icons from "components/icons";

interface IDrawerStandartProps
{
    modalButton: ReactElement;
    extraClass?: string;
    disabled?: boolean;
    width?: number;
    onCancel?: () => void;
    children: ReactElement | ReactElement[];
}

const injectDrawerProps = (
    child: React.ReactNode,
    injectedProps: {
        action: () => void;
        showModal: boolean;
    }
) =>
{
    if (!React.isValidElement(child)) {
        return child;
    }

    if (typeof child.type === "string" || child.type === React.Fragment) {
        return child;
    }

    return React.cloneElement(child, injectedProps);
};

const DrawerStandart = ({
    modalButton,
    extraClass = "",
    disabled = false,
    width = 450,
    onCancel = () => { },
    ...props
}: IDrawerStandartProps) =>
{
    const [ showModal, setShowModal ] = useState(false);

    const handleClose = () =>
    {
        setShowModal(false);
        if (onCancel) {
            onCancel();
        }
    };

    return (
        <>
            {React.cloneElement(modalButton, {
                disabled,
                onClick: () => setShowModal(true),
            })}
            <Drawer
                className={`drawer-standard ${extraClass}`}
                open={showModal}
                width={width}
                placement="right"
                closeIcon={<Icons.Close />}
                onClose={handleClose}
                title={null}
                footer={null}
            >
                <ConfigProvider theme={customizeTheme.LightTheme()}>
                    {React.Children.map(props.children, (child) =>
                        injectDrawerProps(child, {
                            action: handleClose,
                            showModal,
                        })
                    )}
                </ConfigProvider>
            </Drawer>
        </>
    );
};

export default DrawerStandart;
